import {ArchiveBoxIcon} from "@heroicons/react/24/outline";

const PaymentStatusIcon = ({paymentStatus, className}) => {
    return (
        <span>
            {paymentStatus === 'full' && (
                <span>$</span>
            )}
            {paymentStatus === 'partial' && (
                <span>$!</span>
            )}
            {paymentStatus === 'package' && (
                <ArchiveBoxIcon className="w-3 h-3" />
            )}
        </span>
    )
}

export default PaymentStatusIcon;
